import lazyLoadView from '@utils/lazy-load-view';
import uuidv4 from '@utils/uuidv4';
/**
 * Está seccion se encarga de unir el router que esta
 * partido entre todos los routers.
 */
const requireModule = require.context('.', true, /router.js/);
const router = {};

requireModule
	.keys()
	.reverse()
	.forEach((filename) => {
		const rutaBase = filename
			.split('/')
			.filter((x) => !x.match(/(\.|views|router.js)/))
			.join('/');
		const seccionRouter =
			requireModule(filename).default || requireModule(filename);
		const { routes, prefix, childof } = seccionRouter;
		const countRoutes = routes.length;
		for (let j = 0; j < countRoutes; j++) {
			routes[j].path = `${childof ? '' : prefix || `/${rutaBase}`}${routes[j]
				.path || ''}`;
			routes[j].path = routes[j].path === '' ? '/' : routes[j].path;
			if (childof) {
				if (!router[childof].children) {
					router[childof].children = [];
				}
				router[childof].children = [...router[childof].children, routes[j]];
			} else {
				router[routes[j].keygen || uuidv4()] = routes[j];
			}
		}
	});

const allRoutes = Object.values(router);

export default [
	...allRoutes,
	{
		path: '/404',
		name: '404',
		component: require('@views/_404.vue').default,
		props: true
	},
	{
		path: '*',
		redirect: '404'
	},
	{
		path: '/oidc-callback', // Needs to match redirectUri in you oidcSettings
		name: 'oidcCallback',
		component: () => lazyLoadView(import('@views/oidc_callback.vue')),
		meta: {
			isPublic: true
		}
	},
	{
		path: '/oidc-popup-callback', // Needs to match popupRedirectUri in you oidcSettings
		name: 'oidcPopupCallback',
		component: () => lazyLoadView(import('@views/oidc_popup_callback.vue'))
	},
	{
		path: '/signin-oidc-error', // Needs to match redirect_uri in you oidcSettings
		name: 'oidcCallbackError',
		component: () => lazyLoadView(import('@views/oidc_callback_error.vue')),
		meta: {
			isPublic: true
		}
	}
];
